import { getApiBase, resolveMediaUrl } from './api';

export const resolveAssetUrl = (url = '') => {
    if (!url) return '';
    if (url.trim().startsWith('/uploads/')) {
        return resolveMediaUrl(url);
    }

    const base = getApiBase();
    if (base && url.startsWith('/')) {
        return `${base}${url}`;
    }

    return resolveMediaUrl(url);
};

export default resolveAssetUrl;
